<template lang="pug">
div
  .desktop-top.show  
    .container
      .lang-dropdown-wrap(style='top:70px;')
        .traingle-up
        ul#lang-dropdown-list
          li(@click="setLanguage('en')")
            a
              img(src='img/lang/en.svg' alt='' )
              span {{ $t("ui.lang_en") }}
          li(@click="setLanguage('cn')")
            a
              img(src='img/lang/mm.svg' alt='')
              span {{ $t("ui.lang_mm") }}
    .top
      .icon-nav
        img(src='img/icon-nav.svg')
      .logo
        router-link(to="/")
          img.img-fluid(src='img/logo.png')
      .member(v-if="$store.getters.isLoggedIn")
        .d-block.w-100 Hi,
          span.name-width {{getDisplayName}}
        .d-md-none.text-right {{$t('ui.balance')}}: 
          span {{ $numeral($store.getters.balance).format("0,0.00") }}
      .lang-wrap
        .lang-select
          .lang-btn-select
            li(v-if="getLanguage === 'en'")
              a
                img(src="img/lang/en.svg") 
                span {{ $t("ui.lang_en") }}
            li(v-if="getLanguage === 'cn'")
              a
                img(src="img/lang/mm.svg") 
                span {{ $t("ui.lang_mm") }}
      .profile-pic
        img(src="img/icon-user.png")
  .content-center(v-if="showNav")
    .main-nav(:class="{'mb-5' : customPage === true}")
      ul
        li
          router-link(to="/")
            .nav-icon
              img(src='img/nav/home.png')
            .nav-text home
        li(v-if="getKkStatus===true || getNkStatus===true || getLive22Status===true")
          router-link(to="slot")
            .nav-icon
              img(src='img/nav/slot.png')
            .nav-text slot
        li(v-if="getKkStatus===true || getLive22Status===true")
          router-link(to="fishing")
            .nav-icon
              img(src='img/nav/fish.png')
            .nav-text Fishing
        //- li
          router-link(to="casino")
            .nav-icon
              img(src='img/nav/casino.png')
            .nav-text casino
        li
          a(href="javascript:void(0)" @click="launchWbet")
            .nav-icon
              img(src='img/nav/sport.png')
            .nav-text {{$t('ui.sports')}}
        li(v-show="$store.getters.isLoggedIn && getPromoList.length > 0")
          router-link(to="promotions")
            .nav-icon
              img(src='img/nav/promo.png')
            .nav-text {{$t('ui.promotions')}}
        //- li
        //-   a(href="#pills-share" data-toggle="modal" data-target="#modal-reward")
        //-     .nav-icon
        //-       img(src='img/nav/referral.png')
        //-     .nav-text referral
        //- li
          a(href="#pills-reward" data-toggle="modal" data-target="#modal-reward")
            .nav-icon
              img(src='img/nav/rewards.png')
            .nav-text rewards
        //- li
          router-link(to="contactUs")
            .nav-icon
              img(src='img/nav/contact.png')
            .nav-text contact
</template>
<script>
export default {
  data() {
    return {
      feedback: {
        success: true,
        status: ""
      },
      refreshBalance: null,
      loading:false,
      menuDisplay:false,
      url: "",
      mobileDevice: false,
      showNav: true,
      customPage: false,
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    getDisplayName() {
      return this.$store.getters.username || this.$store.getters.accountID
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    getPromoList(){
      return this.$store.getters.promoList.data.PROMOTION_LIST
    },
    getKkStatus(){
			return this.$store.state.user.account.kk
		},
		getLive22Status(){
			return this.$store.state.user.account.live22
		},
		// getLgStatus(){
		// 	return this.$store.state.user.account.lg
		// },
		getNkStatus(){
			return this.$store.state.user.account.nk
		},
  },
  watch:{
    sessionToken(newValue, oldValue){
      if(newValue){
        var vm = this
        this.firstBalance();
        clearInterval(this.refreshBalance);
        this.refreshBalance = setInterval(() => {
          vm.getBalance()
        }, 10000)
      }else{
        clearInterval(this.refreshBalance)
      }
    },
    $route (to, from){
      if(to.path === '/statement' || to.path === '/promotions' || to.path === '/promoDetails' || to.path === '/contactUs'){
        this.customPage = true
        if ($(window).width() < 992) {
          this.showNav = false
        }else{
          this.showNav = true
        }
      }else{
        this.customPage = false
        this.showNav = true
      }
    }
  },
  mounted() {
    var vm = this
    if(vm.$router.currentRoute.fullPath === "/statement" || vm.$router.currentRoute.fullPath === "/promotions" || vm.$router.currentRoute.fullPath === "/promoDetails" || vm.$router.currentRoute.fullPath === "/contactUs"){
      this.customPage = true
    }else{
      this.customPage = false
    }
    this.toggleNav()
    $(window).resize(function () {
      vm.toggleNav()
    });
    $('.icon-nav').click(function(){
      $('.left-wrapper').addClass('d-block');
      $('body').addClass("fixed");
      $('.overlay').show();
    });	
    $('#modal-profile, #modal-reward').on('show.bs.modal', function (event) {
      var button = $(event.relatedTarget)		
      var modal = $(this);
      modal.find('[href="'+button.attr("href")+'"]').tab('show');
    });
    this.getMobile()
    if (this.$store.getters.isLoggedIn) {
      this.getBalance()
      this.getPromo()
      // if(this.getBankList.length < 1 ){
      //   this.getMemberBankList()
      // }
    }
    this.refreshBalance = setInterval(() => {
      if (this.$store.getters.isLoggedIn) {
        this.getBalance()
      }
    }, 8000)
    $(".lang-btn-select").click(function() {
      $(".lang-dropdown-wrap").slideDown("fast");
      $('.overlay').show();
    });
    $(".overlay").click(function() {
      $(".lang-dropdown-wrap").slideUp("fast");
      $('.overlay').hide();
      $('.left-wrapper').removeClass('d-block');
      $('body').removeClass("fixed");
    }); 
  },
  methods:{
    getPromo(){
      if (this.sessionToken) {
        let member_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getPromo", { member_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.$store
                .dispatch("user/sPromo", { data: response.data })
                .then(() => {
                  // let refreshKey = this.$store.getters.refreshKey + 1
                  // this.$store.dispatch("user/setRefreshKey", refreshKey)
                  // this.reset()
                  $('#modal-login').modal('hide')
                  $('body').removeClass('modal-open')
                  $('.modal-backdrop').remove()
                  $(".overlay").removeClass("d-block")
                  // this.$router.push("/").catch(error =>{})
                })
                .catch(err => console.log(err))
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {console.log(response)
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    toggleNav(){
      var vm = this
      if ($(window).width() < 992) {
        if(vm.$router.currentRoute.fullPath === "/statement" || vm.$router.currentRoute.fullPath === "/promotions" || vm.$router.currentRoute.fullPath === "/promoDetails" || vm.$router.currentRoute.fullPath === "/contactUs"){
          vm.showNav = false
        }else{
          vm.showNav = true
        }      
      }else{
        vm.showNav = true
      }
    },
    getMobile() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.mobileDevice = true
      }else{
        this.mobileDevice = false
      }
    },
    redirect(target){
      this.$store.dispatch("user/setSlotSelected", target)
      this.$router.push("slot").catch(error =>{})
    },
    showMenu(){
      this.menuDisplay = true
    },
    setLanguage(payload) {
      $('.overlay').toggle();
      $(".lang-dropdown-wrap").slideUp("fast")
      this.$store.dispatch("user/setLanguage", payload)
    },
    firstBalance(){
      if (this.sessionToken) {
        let member_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBalance", { member_id, auth_token })
          .then(response => {
            if (response.success == true) {
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    getBalance() {
      if (this.sessionToken) {
        let member_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBalance", { member_id, auth_token })
          .then(response => {
            if (response.success == true) {
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              if(response.status === 'sessionExpired'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                this.$store
                  .dispatch("user/logout")
                  .then(this.$router.push("/").catch(error =>{}))
                  .catch(err => {})
              }else{
                console.log(this.$t("message.list.disconnect"))
              }            
              // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }else{
              if(response.status.status == 0){
                if(response.status === 'sessionExpired'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                  this.$store
                    .dispatch("user/logout")
                    .then(this.$router.push("/").catch(error =>{}))
                    .catch(err => {})
                }else{
                  console.log(this.$t("message.list.disconnect"))
                } 
                // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list.disconnect"), "info", this);
                // this.$router.push("/").catch(error =>{})
              }
            }
            // $('body').removeClass('modal-open');
            // $('.modal-backdrop').remove();
          });
      }
    },
    getMemberBankList() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberBankList", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
							// console.log(response)
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }    
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    // launchEpic(code){
    //   if (this.sessionToken) {
    //     let player_id = this.accountID
    //     let auth_token = this.sessionToken
    //     let game_code = code
    //     let lang_code = "en"
    //     this.$store
    //       .dispatch("user/launchEpic", { player_id, auth_token,game_code, lang_code })
    //       .then(response => {
    //         if (response.success == true) {
    //           setTimeout(() => {
		// 						window.open(response.data, "_blank")
		// 					}) 
    //         } else {             
    //           if((typeof response.status) != 'object'){
    //             this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //           }
    //         }
    //       })
    //       .catch(response => {console.log(response)
    //         if((typeof response.status) != 'object'){
    //           this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //         }
    //       });
    //   }else{
    //     return
    //   }
    // },
    // launchHabanero(code){
    //   if (this.sessionToken) {
		// 		var vm = this
    //     let player_id = this.accountID
    //     let auth_token = this.sessionToken
    //     let game_code = ""
    //     let lang_code = this.getLanguage
    //     this.$store
    //       .dispatch("user/launchHabanero", { player_id, auth_token,game_code, lang_code })
    //       .then(response => {
    //         if (response.success == true) {
		// 					setTimeout(() => {
		// 						window.open(response.lobby, "_blank")
		// 					})
    //           // this.redirect(code)
    //         } else {             
    //           if((typeof response.status) != 'object'){
    //             this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //           }
    //         }
    //       })
    //       .catch(response => {
    //         if((typeof response.status) != 'object'){
    //           this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //         }
    //       });
    //   }else{
		// 		return
		// 	}
    // },
    // launchSpadeGaming(code){
    //   if (this.sessionToken) {
		// 		var vm = this
    //     let player_id = this.accountID
    //     let auth_token = this.sessionToken
    //     let game_code = ""
    //     let lang_code = this.getLanguage
    //     this.$store
    //       .dispatch("user/launchSpadeGaming", { player_id, auth_token,game_code, lang_code })
    //       .then(response => {
    //         if (response.success == true) {
		// 					setTimeout(() => {
		// 						window.open(response.lobby, "_blank")
		// 					})
    //           // this.redirect(code)
    //         } else {             
    //           if((typeof response.status) != 'object'){
    //             this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //           }
    //         }
    //       })
    //       .catch(response => {
    //         if((typeof response.status) != 'object'){
    //           this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //         }
    //       });
    //   }else{
		// 		return
		// 	}
    // },
    // launchPGS(){
    //   if (this.sessionToken) {
		// 		var vm = this
    //     let player_id = this.accountID
    //     let auth_token = this.sessionToken
    //     let game_code = ""
    //     let lang_code = this.getLanguage
    //     this.$store
    //       .dispatch("user/launchPGs", { player_id, auth_token,game_code, lang_code })
    //       .then(response => {
    //         if (response.success == true) {
		// 					setTimeout(() => {
		// 						window.open(response.data, "_blank")
		// 					})
    //           // this.redirect(code)
    //         } else {             
    //           if((typeof response.status) != 'object'){
    //             this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //           }
    //         }
    //       })
    //       .catch(response => {
    //         if((typeof response.status) != 'object'){
    //           this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //         }
    //       });
    //   }else{
		// 		return
		// 	}
    // },
    launchWbet(){
      if (this.sessionToken) {
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let type = (this.mobileDevice ? 2 : 1).toString()
        let lang_code = this.getLanguage
        this.$store
          .dispatch("user/launchWbet", { player_id, auth_token,type, lang_code })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
							})
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
				$('#modal-login').modal('show')
			}
    },
  }
}
</script>
<style lang="scss">
.swiper-nav .swiper-wrapper .swiper-slide{
  @media(min-width: 1280px){
    width: 25% !important;
  }
}
.info{
  margin-left: 5px;
  font-size: 12px;
}
// .custom-tooltip .bottom {
//   // min-width:200px;
//   /*max-width:400px;*/
//   top:50px;
//   left:50%;
//   transform:translate(-50%, 0);
//   padding:5px;
//   color:#666666;
//   background-color:#EEEEEE;
//   font-weight:normal;
//   font-size:13px;
//   border-radius:8px;
//   position:absolute;
//   z-index:99999999;
//   box-sizing:border-box;
//   box-shadow:0 1px 8px rgba(0,0,0,0.5);
//   display:none;
//   @media(max-width: 991px){
//     top:40px;
//     min-width: 90px;
//     padding: 3px;
//   }
// }

// .custom-tooltip:hover .bottom {
//   display:block;
// }
.header-right{
  @media(max-width:991px){
    flex-direction: row-reverse;
    .language-wrapper{
      margin-right: 10px;
    }
    .language-wrapper .dropdown-menu{
      transform: translate(-17px, 20px) !important;
    }
  } 
}
</style>
